import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardHeaderComponent } from 'common/card/header/card-header.component';
import { FossInfoService } from 'api';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';

interface FossComponent {
  name: string;
  version: string;
  copyrightEntity?: string;
  licenseText?: string;
  licenseUrl?: string;
  link: string;
}

@Component({
  selector: 'comp-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  imports: [
    TranslateModule,
    CardHeaderComponent,
    AsyncPipe,
    MatProgressSpinner,
    MatProgressSpinnerModule,
  ],
})
export class AboutComponent {
  private readonly fossInfoService = inject(FossInfoService);

  fossInfo$: Observable<FossComponent[]>;

  constructor() {
    this.fossInfo$ = this.fossInfoService.getFossInfo();
  }
}
